import React, { useEffect, useRef } from 'react';
import './BookingConfirmation.css';
import { useLanguage } from './i18n/LanguageContext';

const BookingConfirmation = ({ onComplete }) => {
  const { t } = useLanguage();
  const onCompleteRef = useRef(onComplete);
  onCompleteRef.current = onComplete;

  useEffect(() => {
    const timer = window.setTimeout(() => {
      onCompleteRef.current();
    }, 2500);
    return () => window.clearTimeout(timer);
  }, []);

  return (
    <div className="booking-confirmation-screen">
      <div className="confirmation-container">
        <h1 className="confirmation-title">{t('Request submitted successfully !')}</h1>
        <p className="confirmation-message">{t('Finding you a driver at the earliest.')}</p>
      </div>
    </div>
  );
};

export default BookingConfirmation;
